import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { useHistory } from 'react-router-dom';
import { mobileMenu } from 'constants/menu';
import useTranslate from 'hooks/useTranslate';
import Breakpoints from 'themes/constants/breakpoints';
import {
  NavbarContainer,
  NavbarInner,
  NavbarList,
  NavbarListItem,
  NavbarListItemIcon,
  NavbarListItemText,
} from './NavbarStyles';

export const Navbar = () => {
  const isLaptopL = useMediaQuery({ query: `(${Breakpoints.LAPTOP_L})` });

  const [getText] = useTranslate();

  const history = useHistory();
  const { pathname } = history.location;
  const pathnameSplit = pathname.split('/');

  if (isLaptopL) {
    return null;
  }
  return (
    <NavbarContainer>
      <NavbarInner>
        <NavbarList>
          {mobileMenu.map(({ titlePath, path, icon: Icon }) => {
            // Сравниваю ссылки по первому слову в pathname ...com/СРАВНИВАЕМАЯ_СТРОКА/...
            const tabPathSplit = path.split('/');
            // Беру второй элемент, так как первый всегда равен пустой строке
            const isActive = pathnameSplit?.[1] === tabPathSplit?.[1];

            return (
              <NavbarListItem
                isActive={isActive}
                key={path}
                onClick={() => {
                  history.push(path);
                  document.body.style.overflow = 'hidden scroll';
                }}
              >
                <NavbarListItemIcon isActive={isActive}>
                  <Icon />
                </NavbarListItemIcon>
                <NavbarListItemText>
                  {getText(titlePath)}
                </NavbarListItemText>
              </NavbarListItem>
            );
          })}
        </NavbarList>
      </NavbarInner>
    </NavbarContainer>
  );
};
